import { useState, useEffect } from 'react';
import { codeToHtml } from 'shiki';
import '@magnetic/theme';
import './style.css.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useCodeToHtml = /* @__PURE__ */ __name((code, { language, lineNumbers }) => {
  const [html, setHtml] = useState("");
  const [lineCount, setLineCount] = useState(0);
  useEffect(() => {
    async function setHtmlToState() {
      const html2 = await codeToHtml(code, {
        lang: language,
        theme: language ? "light-plus" : "none",
        transformers: [
          {
            /**
             * Custom transformer to add line numbers to the code block.
             * For each line, this will result in an HTML structure like:
             *
             * <span class="mds-code-line">
             *  <span class="mds-code-line-number">1</span>
             *  <span class="mds-code-line-content">
             *    ...[tokenized output]...
             *   </span>
             * </span>
             */
            line(node, number) {
              return {
                ...node,
                properties: {
                  className: "mds-code-line",
                  "data-line": number
                },
                children: [
                  ...lineNumbers ? [
                    {
                      type: "element",
                      tagName: "span",
                      properties: {
                        className: "mds-code-line-number"
                      },
                      children: [
                        {
                          type: "text",
                          value: number.toString()
                        }
                      ]
                    }
                  ] : [],
                  {
                    type: "element",
                    tagName: "span",
                    properties: {
                      className: "mds-code-line-content"
                    },
                    children: [...node.children]
                  }
                ]
              };
            },
            pre(node) {
              if (language === "text") {
                node.properties.style = void 0;
              }
              node.properties["data-testid"] = "code-block-pre";
            },
            span(node, line, column) {
              node.properties["data-token"] = `token:${line}:${column}`;
            },
            code() {
              setLineCount(this.lines.length);
            }
          }
        ]
      });
      setHtml(html2);
    }
    __name(setHtmlToState, "setHtmlToState");
    setHtmlToState();
  }, [code, language, lineNumbers]);
  const digits = lineCount.toString().length;
  return { html, digits };
}, "useCodeToHtml");

export { useCodeToHtml };
//# sourceMappingURL=use-code-to-html.js.map
